import { render, staticRenderFns } from "./enterprise_news.vue?vue&type=template&id=24ffebc2&scoped=true"
import script from "./enterprise_news.vue?vue&type=script&lang=js"
export * from "./enterprise_news.vue?vue&type=script&lang=js"
import style0 from "./enterprise_news.vue?vue&type=style&index=0&id=24ffebc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ffebc2",
  null
  
)

export default component.exports